import React from 'react';
import styled from 'styled-components';
import AdSmall from './AdSmall';
import AdLarge from './AdLarge';
import Grid from '../Grid/Grid';
import MediaQueryHelper, { MediaQueryHelperDesktop } from '../../../templates/MediaQueryHelper';

const AdRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

const AdColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LayoutAdContainer = (props) => {
  const {
    pageStateModifiers,
    adConfig = {},
    locale,
  } = props;
  const ads = props.ads ? props.ads : [];

  const arrayLargeBanners = ads.map((ad) => {
    const {
      slug = '',
    } = ad;

    return (
      <AdLarge
        key={`ad-large-${slug}`}
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        exclusionsApplyText={adConfig.exclusionsApplyText}
        {...ad} />);
  },
  );

  const arraySmallBanners = ads.map((ad) => {
    const {
      slug = '',
    } = ad;

    return (
      <AdSmall
        key={`ad-small-${slug}`}
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        exclusionsApplyText={adConfig.exclusionsApplyText}
        {...ad}
      />);
  });

  const adsToRender = (mobile) => {
    const AdDirectionToUse = mobile ? AdColumn : AdRow;
    if (ads.length === 1) {
      return (
        <AdDirectionToUse>
          <AdLarge
            {...ads[0]}
            pageStateModifiers={pageStateModifiers}
            exclusionsApplyText={adConfig.exclusionsApplyText}
            locale={locale} />
        </AdDirectionToUse>);
    } else if (ads.length === 2) {
      return <AdColumn>{arrayLargeBanners}</AdColumn>;
    }
    return (
      <AdDirectionToUse>
        { mobile ? arrayLargeBanners : arraySmallBanners }
      </AdDirectionToUse>
    );
  };

  const DesktopChildren = () => (
      adsToRender(false)
  );

  const SmallDesktopChildren = () => (
    <AdColumn>
      { arrayLargeBanners }
    </AdColumn>
  );

  const DesktopBody = () => (
    <MediaQueryHelperDesktop
      desktopChildren={DesktopChildren()}
      smallDesktopChildren={SmallDesktopChildren()} />
  );

  const MobileBody = () => (
      adsToRender(true)
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />);
  return renderComp;
};

export default LayoutAdContainer;
